



































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import AtendimentoFiltro from "@/models/cadastros/saude/AtendimentoFiltro";
import { statusAtendimento } from "@/models/cadastros/saude/StatusAtendimentoModel";
import EspecialidadeModel from "@/models/cadastros/saude/EspecialidadeModel";
import { tiposAtendimentoList } from "@/models/cadastros/saude/TipoAtendimentoModel";
import EspecialidadeAutocomplete from "@/components/saude/EspecialidadeAutocomplete.vue";
import { saudeAtendimentoService } from "@/service/cadastro/saude/atendimento/SaudeAtendimentoService";
import { PaginationModel } from "@/models/commons/PaginationModel";

@Component({
  components: {
    EspecialidadeAutocomplete,
  },
})
export default class ListaAtendimentos extends Vue {
  listaStatusAtendimento = statusAtendimento;
  listaEspecialidades: EspecialidadeModel[] = [];
  listaTipoAtendimento = tiposAtendimentoList;
  listaAtendimentos = [];
  loading: boolean = false;
  tipoPessoa = "F";
  cpfPrestador = "";
  cnpjPrestador = "";

  tiposPessoa = [
    { text: "Pessoa física", value: "F" },
    { text: "Pessoa jurídica", value: "J" },
  ];

  cabecalho = [
    { text: "Data da solicitação", value: "data", width: "10%" },
    { text: "Número atendimento", value: "numeroAtendimento", width: "16%" },
    { text: "Tipo de atendimento", value: "tipoAtendimento", width: "10%" },
    { text: "Especialidade", value: "especialidade", width: "20%" },
    { text: "Status", value: "status", width: "8%" },
    { text: "Atendente Responsável", value: "nomeResponsavel", width: "18%" },
    { text: "Prazo retorno", value: "dataPrevistaRetorno", width: "12%" },
    { text: "Ações", value: "actions", sortable: false, width: "10%" },
  ];

  @Watch("options.page")
  handlePagination() {
    this.getData();
  }

  getData() {
    this.loading = true;
    saudeAtendimentoService
      .pesquisar(this.filtro, this.options, this.cpfPrestador, this.cnpjPrestador, this.tipoPessoa)
      .then((res: any) => {
        this.listaAtendimentos = res.content;
        this.options.itemsLength = res?.totalElements;
      })
      .finally(() => {
        this.loading = false;
      });

  }

  @Watch("options.itemsPerPage")
  filtrar() {
    if(this.options.page == 1) {
        this.getData();
    } else {
      this.options.page = 1;
    }
  }


  options: PaginationModel = {
    itemsPerPage: 5,
    page: 1,
    itemsLength: 1,
  };

  filtro: AtendimentoFiltro = {
    numeroAtendimento: "",
    dataInicio: "",
    tipoAtendimento: undefined,
    dataFim: "",
    status: undefined,
    especialidade: undefined,
    cpfCnpjPrestador: "",
    nomePrestador: "",
    cpfCliente: "",
    nomeCliente: "",
  };

  exibirDetalhe(id: number) {
    this.$router.push({
      name: "DetalheAtendimento",
      params: { idAtendimento: id.toString() },
    });
  }
}
